module.exports = __webpack_amd_options__;



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/buildin/amd-options.js
 ** module id = 180
 ** module chunks = 0 1 2 3 4 5 6
 **/